<div
  class="flex flex-1 overflow-auto"
  [class.mw-form--sidebar-right]="showSidebar === 'right'"
  [class.mw-form--sidebar-left]="showSidebar === 'left'"
  [style.--mw-forms-count]="2"
  [style.--mw-form-section-divider-width]="sectionDividerWidth"
>
  <div class="root-container flex-1 auto-rows-max" #rootContainer>
    <mw-form-sidebar
      class="mw-form__sidebar"
      *ngIf="showSidebar === 'right' || showSidebar === 'left'"
    >
      <mw-form-navigation></mw-form-navigation>
    </mw-form-sidebar>
    <div
      class="form-container rounded border border-graphite-100"
      #formContainer
    >
      <!--
      -- Form title
      -->
      <mw-form-title
        *ngIf="formTitle || formSubTitle"
        class="col-span-full"
        [title]="formTitle"
        [subTitle]="formSubTitle"
      ></mw-form-title>

      <!--
      -- Form content
      -->
      <mw-form-section [sectionDividerWidth]="0">
        <ng-content></ng-content>
      </mw-form-section>
      <ng-content select="mw-form-section"></ng-content>

      <!--
      -- In form action bar
      -->
      <div
        class="form-actions col-span-full mt-[24px]"
        *ngIf="!stickyActionBar && formActions"
      >
        <ng-container
          *ngIf="formActions"
          [ngTemplateOutlet]="formActions.templateRef"
        ></ng-container>
      </div>
    </div>
  </div>
</div>
<!--
-- Stick action bar
-->
<div class="form-sticky-action-bar" *ngIf="stickyActionBar">
  <div class="form-actions" #stickyBarContainer>
    <ng-container
      *ngIf="formActions"
      [ngTemplateOutlet]="formActions.templateRef"
    ></ng-container>
  </div>
</div>
